import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function H({ langKey }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');

    return (
        <div className={`power-ocean-collection-H ${css['power-ocean-collection-H']}`}>
            <div className="text-box">
                <p className="title">{t('secH_title')}</p>
                <p className="desc">{t('secH_desc')}</p>
            </div>
            <div className="img">
                <NextImage src={require('@publicLocal/power-ocean/collection/pc/de/8.jpg')} alt={t('secH_title')} aria-label={t('secH_title')} />
            </div>
        </div>
    );
}
